export const getDetailsArray = (data: any) => {
  const parentKeyArray = ['name', 'relationship', 'homePhone', 'officePhone', 'cellphone', 'email', 'userAccountDetailId'];
  const { tabIndex } = data;
  const detailsArray = [];
  for (let index = 0; index <= tabIndex; index += 1) {
    const settingObject: any = {};
    parentKeyArray.forEach((key: any) => {
      const [realKey] = key.split('_');
      const nowKey = `${key}_${index}`;
      if (data[nowKey] !== undefined) {
        settingObject[realKey] = data[nowKey];
      }
    });
    detailsArray.push({ ...settingObject });
  };
  return detailsArray;
}